<template>
  <div>
    <div class="position-relative dinA4">
      <img :src="require('@/assets/aduaneros-header.png')" class="page__header" />
      <div class="page__container">
        <table class="full-width mt-0">
          <tr class="primary-background">
            <th colspan="5" class="primary-background h1 color-white text-center pl-4 mb-0 pb-2">
              Gestión Aduanera Melilla
            </th>
          </tr>
          <tr class="dark-grey-background">
            <td class="body-2 color-white text-center pb-2 big-cell" />
            <td colspan="2" class="body-2 color-white text-center pb-2">Origen (*)</td>
            <td colspan="2" class="body-2 color-white text-center pb-2">Destino (**)</td>
          </tr>
          <tr class="dark-grey-background tr-collapsed">
            <td class="body-2 text-center color-white pb-2 big-cell">VALOR DE LA MERCANCÍA</td>
            <td class="body-2 color-white text-center pb-2">Península<br />DUA/GAS Exportación</td>
            <td class="body-2 color-white text-center pb-2">Melilla<br />DUA/GAS Exportación</td>
            <td class="body-2 color-white text-center pb-2">
              Melilla<br />DUA/GAS Importación (1)
            </td>
            <td class="body-2 color-white text-center pb-2">
              Península<br />DUA/GAS Importación (2)
            </td>
          </tr>
          <tr>
            <td class="body-2">Trámite Aduanas</td>
            <td class="body-2 text-center">
              {{ getAdditionalServiceById('DUA_MEL_ALTO_EX_PEN').value
              }}<span class="euro-symbol">€</span>
            </td>
            <td class="body-2 text-center">
              {{ getAdditionalServiceById('DUA_MEL_ALTO_IM_PEN').value
              }}<span class="euro-symbol">€</span>
            </td>
            <td class="body-2 text-center">-</td>
            <td class="body-2 text-center">
              {{ getAdditionalServiceById('DUA_MEL_ALTO_IM_PEN').value
              }}<span class="euro-symbol">€</span>
            </td>
          </tr>
        </table>

        <div class="d-flex justify-space-between mt-2">
          <ul class="list-style-none body-2">
            <li class="pl-2">
              (1) No incluye Impuesto aduanero de importación IPSI entrada a Melilla
            </li>
            <li class="pl-2">(2) No incluye IVA de importación entrada a Península</li>
          </ul>
          <ul class="list-style-none body-2">
            <li class="pl-4">(*) Exento de Impuestos</li>
            <li class="pl-4">(**) Impuestos no Incluidos</li>
          </ul>
        </div>

        <table class="full-width mt-2">
          <tr class="primary-background">
            <th colspan="5" class="primary-background h1 color-white text-center pl-4 mb-0 pb-2">
              Gestión Aduanera Ceuta & Gibraltar & Andorra
            </th>
          </tr>
        </table>

        <div class="d-flex">
          <table class="full-width mt-0 mr-2">
            <tr class="dark-grey-background">
              <td colspan="4" class="body-2 color-white text-center pb-2">
                Origen (*)<br />DUA Exportación
              </td>
            </tr>

            <tr class="dark-grey-background">
              <td class="body-2 color-white text-center pb-2">De</td>
              <td class="body-2 color-white text-center" />
              <td class="body-2 color-white text-center">A</td>
              <td class="body-2 color-white text-center" />
            </tr>
            <tr>
              <td class="body-2 text-center pb-2">Península</td>
              <td class="body-2 text-center pb-2">
                {{ getAdditionalServiceById('DUA_CEU').value }}<span class="euro-symbol">€</span>
              </td>
              <td class="body-2 text-center pb-2">Ceuta</td>
              <td class="body-2 text-center pb-2">
                {{ getAdditionalServiceById('DUA_CEU').value }}<span class="euro-symbol">€</span>
              </td>
            </tr>
            <tr>
              <td class="body-2 text-center pb-2">Península</td>
              <td class="body-2 text-center pb-2">
                {{ getAdditionalServiceById('DUA_GIB').value }}<span class="euro-symbol">€</span>
              </td>
              <td class="body-2 text-center pb-2">Gibraltar</td>
              <td class="body-2 text-center pb-2">
                {{ getAdditionalServiceById('DUA_GIB').value }}<span class="euro-symbol">€</span>
              </td>
            </tr>
            <tr>
              <td class="body-2 text-center pb-2">Península (3)</td>
              <td class="body-2 text-center pb-2">
                {{ getAdditionalServiceById('DUA_AND').value }}<span class="euro-symbol">€</span>
              </td>
              <td class="body-2 text-center pb-2">Andorra (3)</td>
              <td class="body-2 text-center pb-2">
                {{ getAdditionalServiceById('DUA_AND').value }}<span class="euro-symbol">€</span>
              </td>
            </tr>
          </table>

          <table class="full-width mt-0">
            <tr class="dark-grey-background"></tr>
            <tr class="dark-grey-background">
              <td colspan="4" class="body-2 color-white text-center pb-2">
                Destino (**)<br />DUA Importación
              </td>
            </tr>
            <tr class="dark-grey-background">
              <td class="body-2 color-white text-center pb-2">De</td>
              <td class="body-2 color-white text-center" />
              <td class="body-2 color-white text-center">A</td>
              <td class="body-2 color-white text-center" />
            </tr>
            <tr>
              <td class="body-2 text-center pb-2">Ceuta (1)</td>
              <td class="body-2 text-center pb-2">-</td>
              <td class="body-2 text-center pb-2">Península (2)</td>
              <td class="body-2 text-center pb-2">
                {{ getAdditionalServiceById('DUA_CEU').value }}<span class="euro-symbol">€</span>
              </td>
            </tr>
            <tr>
              <td class="body-2 text-center pb-2">Gibraltar</td>
              <td class="body-2 text-center pb-2">
                {{ getAdditionalServiceById('DUA_GIB').value }}<span class="euro-symbol">€</span>
              </td>
              <td class="body-2 text-center pb-2">Península</td>
              <td class="body-2 text-center pb-2">
                {{ getAdditionalServiceById('DUA_GIB').value }}<span class="euro-symbol">€</span>
              </td>
            </tr>
            <tr>
              <td class="body-2 text-center pb-2">Andorra (3) (4)</td>
              <td class="body-2 text-center pb-2">
                {{ getAdditionalServiceById('DUA_AND').value }}<span class="euro-symbol">€</span>
              </td>
              <td class="body-2 text-center pb-2">Península (3) (5)</td>
              <td class="body-2 text-center pb-2">
                {{ getAdditionalServiceById('DUA_AND').value }}<span class="euro-symbol">€</span>
              </td>
            </tr>
          </table>
        </div>
        <div class="d-flex justify-space-between mt-2">
          <ul class="list-style-none body-2">
            <li class="pl-2">(1) No incluye Impuesto aduanas IPSI Ceuta</li>

            <li class="pl-2">
              (2) No incluye IVA de importación origen Ceuta - entrada a Península
            </li>

            <li class="pl-2">(3) No incluye Transitario español/andorrano</li>
            <li class="pl-2">(4) No incluye el Impuesto de importación entrada a Andorra</li>
            <li class="pl-2">(5) No incluye IVA de importación origen de entrada a Península</li>
          </ul>
          <ul class="list-style-none body-2">
            <li class="pl-4">(*) Exento de Impuestos</li>
            <li class="pl-4">(**) Impuestos no incluidos</li>
          </ul>
        </div>
      </div>

      <Footer logo :page="previousPages + 1" />
    </div>
  </div>
</template>

<script>
import Footer from '@/containers/offer-form/sign-off/pdf-venta-directa-2026/Footer'

export default {
  name: 'Aduaneros',
  components: { Footer },
  data() {
    return {
      previousPages: 0,
    }
  },
  methods: {
    getAdditionalServiceById(id) {
      return this.$parent.getAdditionalServiceById(id)
    },
    getAdditionalServiceByDesc(desc) {
      return this.$parent.getAdditionalServiceByDesc(desc)
    },
  },
  mounted() {
    this.previousPages = this.$parent.sectionPreviousPages('Aduaneros')
  },
}
</script>
